import React from 'react';

import { getObjectTiles, getObjectTileSizes } from '../helpers';
import type { ObjectTileData } from '../types';

import { BaseExplorer } from './base-explorer';

type ObjectTileExplorerProps = {
	testId?: string;
};

export function ObjectTileExplorer({ testId }: ObjectTileExplorerProps): React.JSX.Element {
	return (
		<BaseExplorer<ObjectTileData>
			testId={testId}
			isObjectTile
			getObjects={getObjectTiles}
			getSizes={getObjectTileSizes}
		/>
	);
}
